<template>
  <div class="app-acesso-conta">
    <!-- SETA O STATUS DA PAGINA -->
    <RF-Status v-if="statusGeral !== ''" :cpntStatus="statusGeral" :cpntIcone="false" :cpntTamanho="5"></RF-Status>
    
    <!-- SETA OS DADOS DA PAGINA -->
    <div v-else>
      <!-- SETA AS MENSAGENS DE ERRO RECEBIDA NA ROTA -->
      <div class="erros" v-if="[ '', null, undefined ].indexOf($route.params) === -1 && [ '', null, undefined ].indexOf($route.params.error) === -1">
        <div>
          <span v-html="$route.params.error"></span>
        </div>
      </div>

      <!-- SETA O TITULO DA PAGINA -->
      <div class="titulo">Escolha uma conta</div>

      <!-- SETA OS DADOS PARA O QUADRADO E SUAS CONTAS -->
      <div class="quadrado">
        <template v-for="(conta, clu, indexC) in $store.state.contas">
          <div :key="'conta-' + indexC" @click="appAcessoContasEntrarConta(clu)" v-if="conta.salvar === true || (conta.conectado === true && flagSuporteRF === true)">
            <table>
              <tr>
                <!-- SETA A LOGO TIPO DO CLIENTE -->
                <td class="logo">
                  <img :src="conta.logotipo" :ref="'logo-' + indexC" @load="appAcessoContasLogotipoCarregarTamanho('logo-' + indexC)">
                </td>

                <td class="dados">
                  <!-- SETA OS DADOS DA CONTA -->
                  <div class="conta">{{ conta.conta }}</div>

                  <!-- SETA A RAZÃO SOCIAL DA EMPRESA -->
                  <div class="azul">
                    <span v-if="[ '', null, undefined ].indexOf(conta.licenca) === -1 && [ '', null, undefined ].indexOf(conta.licenca.rSocial) === -1" v-html="conta.licenca.rSocial"></span>
                  </div>

                  <!-- SETA A CNPJ DA EMPRESA -->
                  <div class="azul">
                    <span v-if="[ '', null, undefined ].indexOf(conta.licenca) === -1 && [ '', null, undefined ].indexOf(conta.licenca.cnpj) === -1" v-html="conta.licenca.cnpj"></span>
                  </div>

                  <!-- MOSTRA SE A CONTA ESTÁ CONECTADA OU NÃO -->
                  <div class="desconectado">
                    <span v-if="conta.conectado === false">Desconectado</span>
                  </div>
                </td>

                <td class="acoes">
                  <!-- SETA O BOTÃO PARA REMOVER A CONTA -->
                  <RF-Button :data-time="time"
                    :cpntStatus="''"
                    :cpntId="'app-acesso-contas-remover--' + indexC" 
                    :cpntIcone="'fa fa-times'" 
                    :cpntClass="[ 'btn', 'btn-sm', 'btn-default']"
                    @onClickButton="appAcessoContasRemoverConta(conta)"
                  ></RF-Button>

                  <!-- SETA O ICONE PARA ABRIR A CONTA -->
                  <i class="fa fa-chevron-right"></i>
                </td>
              </tr>
            </table>
          </div>
        </template>
      </div>
      
      <!-- SETA O BOTÃO PARA ENTRAR COM OUTRA CONTA -->
      <router-link tag="button" class="btn btn-primary app-acesso-conta-outras" :to="{ name: 'pag_ace', params: {} }" target='_parent'>Entrar com outra conta</router-link>

      <!-- SETA O BOTÃO PARA ENTRAR NA VERSÃO ANTIGA -->
      <!-- <router-link v-if="$store.state.mobile === false && ELECTRON === false" class="app-acesso-antigo" :to='{ name: "ver-antiga" }' tag='a'>Ir para a versão antiga</router-link> -->
    </div>
  </div>
</template>

<style scoped>
.app-acesso-conta {
  padding-top: 140px;
  text-align: center;
  overflow-x: auto;
}
  .app-acesso-conta > div > .erros {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
    .app-acesso-conta > div > .erros > div {
      color: #a94442;
      display: inline-block;
      background-color: #f2dede;
      border: 1px solid #cc939c;
      border-radius: 3px;

      -moz-box-shadow: #5a5a5a 2px 2px 4px;
      -webkit-box-shadow: #5a5a5a 2px 2px 4px;
      box-shadow: #5a5a5a 2px 2px 4px;
      padding: 5px 30px;
    }
  
  .app-acesso-conta > div > .titulo {
    text-align: center;
    font-size: var(--font-base-soma-20);
    font-weight: 500;
    margin-bottom: 10px;
  }

  .app-acesso-conta > div > .quadrado {
    background: #fff;
    -webkit-box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12),0 1px 5px 0 rgba(0,0,0,.2);
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12),0 1px 5px 0 rgba(0,0,0,.2);
    border-radius: 5px;
    max-width: 365px;
    width: 98%;
    margin: 15px auto;
  }
    .app-acesso-conta > div > .quadrado > div {
      padding: 10px 5px;
      border: 1px solid #dedede;
      cursor: pointer;
    }
    .app-acesso-conta > div > .quadrado > div:first-child {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
    .app-acesso-conta > div > .quadrado > div:last-child {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
      .app-acesso-conta > div > .quadrado > div > table {
        width: 100%;
      }
        .app-acesso-conta > div > .quadrado > div > table > tr > td.logo {
          width: 100px;
          padding-left: 5px;
        }
          .app-acesso-conta > div > .quadrado > div > table > tr > td.logo > img {
            vertical-align: middle;
          }
        .app-acesso-conta > div > .quadrado > div > table > tr > td.dados {
          height: 60px;
          padding-left: 8px;
          line-height: 18px;
          text-align: left;
        }
          .app-acesso-conta > div > .quadrado > div > table > tr > td.dados > .azul {
            font-size: 14px;
          }
          .app-acesso-conta > div > .quadrado > div > table > tr > td.dados > .azul {
            color: #015cf4;
            font-size: 12px;
          }
          .app-acesso-conta > div > .quadrado > div > table > tr > td.dados > .desconectado {
            font-size: 12px;
            font-style: italic;
          }
        .app-acesso-conta > div > .quadrado > div > table > tr > td.acoes {
          width: 15px;
          text-align: right;
          vertical-align: top;
        }
          
          .app-acesso-conta > div > .quadrado > div > table > tr > td.acoes > button {
            float: right;
            position: relative;
            top: -10px;
            right: -5px;
            padding: 3px 8px;
            opacity: 0.65;
            margin-bottom: 8px;
            border: none;
          }
          .app-acesso-conta > div > .quadrado > div:hover > table > tr > td.acoes > button {
            opacity: 1;
          }
          .app-acesso-conta > div > .quadrado > div > table > tr > td.acoes > svg {
            color: #989898;
            font-size: 24px;
            opacity: 0.65;
          }
          .app-acesso-conta > div > .quadrado > div:hover > table > tr > td.acoes > svg {
            opacity: 1;
          }

  .app-acesso-conta >  div > .app-acesso-conta-outras {
    margin: 10px 0px;
  }

  .app-acesso-conta >  div > .app-acesso-antigo {
    position: fixed;
    right: 5px;
    bottom: 2px;
  }
</style>

<style>
  .app-acesso-conta > div > .quadrado > div > table > tr > td.acoes > button > svg {
    color: #c9c9c9;
  }

  .app-acesso-conta > div > .quadrado > div:hover > table > tr > td.acoes > button > svg {
    color: #ccc;
  }
</style>

<script>
  export default {
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        flagSuporteRF: false,
        ELECTRON: window.ELECTRON
      }
    },
    mounted: function () {
      this.appAcessoContasIniciar()
    },
    methods: {
      appAcessoContasIniciar: function () {
        // SETA O STATUS CARREGANDO DA PAGINA
        this.appAcessoContasStatusGeral('carregando')

        // REALIZA O PREENCHIMENTO NO VUEX DAS INFORMAÇOES
        this.$store.commit('SET_TOKEN', {})

        // // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
        // const FUN_MOSTRAR_SCROLL_BODY = require('@/assets/js/Funcoes-Gerais.js').FUN_MOSTRAR_SCROLL_BODY

        // // SETA SE DEVE ATIVAR O SROLL DO BODY OU NÃO
        // FUN_MOSTRAR_SCROLL_BODY(true)

        // SETA QUE NÃO DEVE MOSTRAR SUPORTERF
        this.flagSuporteRF = false

        // SETA O FLAG SE DEVE ABRIR OU NÃO A PAGINA
        var flag = false

        // VERIFICA SE TEM ALGUMA CONTA VALIDA
        if ([ '', null, undefined ].indexOf(this.$store.state.contas) === -1 && Object.keys(this.$store.state.contas).length >= 1) {
          // COPIA A VARIAVEL DE CONTAS
          var contas = JSON.parse(JSON.stringify(this.$store.state.contas))
  
          // VERIFICA SE TEM ALGUMA CONTA CADASTRADA
          if (Object.keys(contas).length >= 1) {
            // VERIFICA SE TEM AO MENOS DUAS DAS CONTAS INFORMADAS ABAIXO
            if (Object.keys(contas).filter(item => [ 'Luis@9000', 'testes@9124', 'Luis@1001', 'Luis@1002' ].indexOf(item) !== -1).length >= 2) {
              this.flagSuporteRF = true
            }
  
            // SETA O STATUS CARREGANDO DA PAGINA
            if (Object.keys(contas).filter(item => (contas[item].salvar === true || (this.flagSuporteRF === true && contas[item].conectado === true))).length >= 1) {
              flag = true
            }
          }
        }

        // VERIFICA SE FOI ENCONTRADO ALGUMA CONTA VALIDA PARA CARREGAR
        switch (flag) {
          // LIBERA A ABERTURA DA PAGINA
          case true:
            this.appAcessoContasStatusGeral('')
            break
          
          // MANDA PARA TELA DE LOGIN
          case false:
            this.appAcessoContasEntrarConta()
            break
        }
      },
      appAcessoContasStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      appAcessoContasEntrarConta: function (conta = '') {
        // SETA O STATUS CARREGANDO DA PAGINA
        this.appAcessoContasStatusGeral('carregando')

        // VERIFICA A CONTA QUE DEVE ABRIR
        switch (conta) {
          case '':
            this.$router.push({ name: "pag_ace", params: {} })
            break

          default:
            this.$router.push({ name: "pag_ace", params: this.$store.state.contas[conta] })
            break
        }
      },
      appAcessoContasRemoverConta: function (conta) {
        if (window.confirm('Deseja realmente excluir a conta "' + conta.conta + '"?')) {
          // SETA O STATUS CARREGANDO DA PAGINA
          this.appAcessoContasStatusGeral('carregando')

          // IMPORTA A FUNÇÃO PARA REMOVER A CONTA DO CS
          const SESSAO_REMOVER_CONTA = require('@/assets/js/Sessao.js').SESSAO_REMOVER_CONTA

          // CHAMA A FUNÇÃO PARA REMOVER A CONTA DO LS_WEB
          SESSAO_REMOVER_CONTA(conta).then(() => { this.appAcessoContasIniciar() })
        }
      },
      appAcessoContasLogotipoCarregarTamanho: function (chave) {
        // IMPORTA A FUNÇÃO
        const FUN_REDIMENCIONAR_IMAGEM = require('@/assets/js/Funcoes-Gerais.js').FUN_REDIMENCIONAR_IMAGEM

        // CHAMA A FUNÇÃO PARA REDIMENCIONAR IMAGEM PROPORCIONAMENTE
        FUN_REDIMENCIONAR_IMAGEM(this.$refs[chave], 100, 45)
      }
    }
  }
</script>
